import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './test.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
  Heading4
} from '../../../../landingComponents/typography';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';
import LandingButton from 'src/components/landingComponents/button';
import { TestDescription } from './oak';

const OtherTests = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Heading4 className={styles.header} accent>
        Иные часто используемые тесты
      </Heading4>
      <InfoBlock />
      <div className={styles.bottom}>
        <SubTitle accent>
          Эти исследования помогают получить полную картину состояния здоровья и
          выявить возможные нарушения на ранних этапах.
        </SubTitle>
        <LandingButton variant="contained" href="/questions">
          <Button>Загрузить анализы</Button>
        </LandingButton>
      </div>
    </CommonLandingContainer>
  );
};

export default OtherTests;

const InfoBlock = () => {
  return (
    <AnimatedBox className={getClassName([styles.right])}>
      <div className={styles.rightText}>
        <div className={styles.infoText}>
          <TestDescription
            accentText="Гормоны щитовидной железы "
            text=" (например, ТТГ, Т3, Т4) — для оценки её функции."
          ></TestDescription>
          <TestDescription
            accentText="Женские половые гормоны "
            text=" (эстроген, прогестерон и др.) — важны для диагностики гормональных нарушений."
          ></TestDescription>
          <Title>Кроме того, часто сдаются:</Title>
          <TestDescription
            accentText="Коагулограмма "
            text=" — анализ свёртываемости крови."
          ></TestDescription>
          <TestDescription
            accentText="Показатели обмена железа "
            text="(ферритин, трансферрин и др.) — для диагностики анемии и других состояний."
          ></TestDescription>
          <TestDescription
            accentText="Анализы на инфекции "
            text=" — выявление вирусных, бактериальных или других инфекционных заболеваний."
          ></TestDescription>
        </div>
      </div>
    </AnimatedBox>
  );
};
